import BaseModel from '../../../../base/base_model';
import {T3D_TOUCH} from './three_d_touch_consts';
import {KEY_NAME} from '../../native/native_const';
import Store from '../../../../utils/store';


class ThreeDTouchModel extends BaseModel {

    static CLASS = 'ThreeDTouchModel';

    _gameCaption = '';
    _params='';

    /*
     * init the params to be an json object.
     * @params is string from web.config
     * @params is json object from html
     */
    init(params) {

        this._params = params;
        super.init(params);
    }

    setShourtcutGameCaption(caption) {
        this._gameCaption = caption;
    }

    getShourtcutGameCaption() {
        return this._gameCaption;
    }

    saveInitGameId(newGameId) {

        let prevGameId = Store.get(T3D_TOUCH.INIT_GAME_ID, '0');

        if (newGameId !== prevGameId) {
            Store.set(T3D_TOUCH.INIT_GAME_ID, newGameId);
            this.saveRecentlyPlayedGame(newGameId);
        }
    }

    saveRecentlyPlayedGame(gameId) {
        Store.set(T3D_TOUCH.RECENTLY_PLAYED_GAME_ID, gameId);
    }

    getRecentlyPlayedGame() {
        let gameId = Store.get(T3D_TOUCH.RECENTLY_PLAYED_GAME_ID, '0');
        return gameId;
    }


    getParams() {
        return this._params ? this._params.ShourtcutsLaunch : '';
    }

    getUpdateShortcutDataObj(action, caption = '', val = '') {

        let data = {
            [T3D_TOUCH.ACTION]: action,
            [T3D_TOUCH.CAPTION]: caption,
            [T3D_TOUCH.VAL]: val
        };

        return JSON.stringify(data);
    }

    getShortcutLaunch(data) {
        let error = data[KEY_NAME.ERROR];
        if (error !== 0) {
            return null;
        }

        let shortcut = data[KEY_NAME.DATA];

        return shortcut;
    }

}

export default ThreeDTouchModel;